<template>
    <div class="contentHome">
        <div class="centerPage">
            <tabCommon></tabCommon>
            <div class="right">
                <div class="title flex">
                    <span>专家讲座</span>
                    <div class="btnTab">
                        <el-button size="mini" @click="changeStatus(0,-1)" :class="active==0?'activeIndex':''">全部({{count.all}})</el-button>
                        <el-button size="mini" @click="changeStatus(1,0)" :class="active==1?'activeIndex':''">待开始({{count.s0}})</el-button>
                        <el-button size="mini" @click="changeStatus(2,1)" :class="active==2?'activeIndex':''">会诊中({{count.s1}})</el-button>
                        <el-button size="mini" @click="changeStatus(3,2)" :class="active==3?'activeIndex':''">已结束({{count.s2}})</el-button>
                    </div>
                </div>
                <div class="formUserInfo">
                    <div class="cnHomeTabsItem flex"
                         v-for="(obj,index) in page.rows"
                         :key="index">
                        <div class="avatar img" :style="'backgroundImage: url('+obj.thumbnailPath+')'"></div>
                        <div class="rightHome">
                            <h2 class="overflow">{{obj.title}}</h2>
                            <p class="overflow">{{obj.subTitle}}</p>
                            <div class="flex">
                                <span :class="obj.state==1?'yellow':obj.state==2?'green':'cost'">{{obj|stateFmt}}</span>
                                <el-button size="mini" class="solid" @click="toLectureDetails(obj.id)">查看详情</el-button>
                            </div>

                        </div>
                    </div>
                    <div class="empty" v-if="page.rows.length==0">
                        <img src="../../assets/img/no.png" alt="" width="200">
                        <p>这里什么都没有</p>
                    </div>
                    <el-pagination
                            class="pagination"
                            background
                            prev-text="Prev"
                            next-text="Next"
                            @current-change="skipPage"
                            :current-page="page.current"
                            :page-size="page.size"
                            layout="prev, pager, next"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import base from '@/api/common';
    export default {
        name: "expertLect",
        data() {
            return {
                active: 0,
                count:{
                    all: 0,
                    s0: 0,
                    s1: 0,
                    s2: 0
                },
                page:{
                    current: 1,
                    size: 5,
                    total: 5,
                    rows: [],
                    status: -1,
                }

            }
        },
        components: {
            'tabCommon': () => import('./tabCommon'),
        },
        methods: {
            changeStatus(index,status){
                this.active = index;
                this.page.status = status;
                this.page.current = 1;
                this.getData();
            },
            toDetail() {
                this.$router.push({name: 'phyDetail'})
            },
            toLectureDetails(id){
                this.$router.push({name: 'lectureDetail', query: {id: id}});
            },
            // 当前页
            skipPage(current) {
                this.page.current = current;
                this.getData();
            },
            getData(){
                this.$ajax.get(base.api.expert.lecture.list_me,{params:{
                        page: this.page.current,
                        size: this.page.size,
                        status: this.page.status
                }}).then((res)=>{
                    if(res.data.status === 'success'){
                        this.page.rows = res.data.rows;
                    }
                })
            },
        },
        mounted() {
            this.$ajax.get(base.api.expert.lecture.count).then((res)=>{
                if (res.data.status === 'success'){
                    this.count = res.data.data;
                }
            });
            this.getData();
        },
        filters:{
            stateFmt(item){
                if (item) {
                    //item
                    let s = new Date(item.startDate.replace(/-/g, "/"));
                    let e = new Date(item.endDate.replace(/-/g, "/"));
                    let cur = new Date();

                    if (e.getTime() <= cur.getTime()) {
                        item.state = 3;
                        return "已结束";
                    }
                    if (s.getTime() > cur.getTime()) {
                        item.state = 0;
                        return "待开始";
                    }
                    if (s.getTime() <= cur.getTime() && e.getTime() >= cur.getTime()) {
                        item.state = 1;
                        return "进行中";
                    }
                    return "-";
                }
                return "已结束";
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/personalCenter.scss";

    .cnHomeTabsItem {
        .avatar {
            width: 150px;
            height: 100px;
        }

        .rightHome {
            width: calc(100% - 170px);
            h2{
                height: 39px;
            }
            p{
             height: 26px;
            }
        }
    }
</style>